
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// const home = "http://localhost:4000"
// const home = "https://api-livepad.webdemoapps.com" //dev environment
const home = "https://dev-api.livepad.pro"   //stage environment 
// const home = "https://uat-api-livepad.webdemoapps.com"
// export const environment = {
//   production: false,
//   graphApi: home
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.




export const environment = {
	production: false,
	devProd:true,
	host: home,
	graphApi: home,
	gtagId:home==="https://dev-api.livepad.pro"?'G-62NYYJHZ5K':'G-62NYYJHZ5K',
	env: 'Dev',
	aws:{
		AWS_REGION:'us-east-1',
		// AWS_KEY:'AKIA2AJHIM4LQQAWOZW6',
		AWS_KEY:'AKIAR5SD3SRFQ75AOI6H',
		// AWS_SECRET_KEY:'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',
		AWS_SECRET_KEY:'vHeEbv1X0olAFn/fW93D6o8PtASjA+Dv5MFb6deJ',
		IdentityPoolId:"us-east-1:db89f006-9540-4624-acae-908c0fb45546",
		pool_id:'us-east-1:db89f006-9540-4624-acae-908c0fb45546',
		// bucketNameVideo:'livepad-source',
		bucketNameVideo:'livepad-media',
		// bucketNameImage:'livepad-images',
		bucketNameImage:'livepad-image',
		// bucket:'https://d3o40wwl2vh905.cloudfront.net'
		bucket:'https://dkx2r6ndffbfa.cloudfront.net'


	},
	imagePlaceholder: "./assets/avatar.jpg",
	restApi: { 
		agentAvatarUpload: `${home}/agentAvatar`,
		clientAvatarUpload: `${home}/clientAvatar`,
		propertyPhotoUpload: home + "/propertyPhoto",
		orgAvatarUpload: `${home}/orgAvatar`,
		docUpload: `${home}/masterDocuments`,
		agentDocUpload: `${home}/docUploadLogs`,
		getAllDocsStatus: `${home}/getLogsDocStatus`
	},
	maps: {
		google: {
			apiKey: "AIzaSyC8Q6s5m_EMZzBQCLpmgmVJngVB7SpWVEE"
		}
	},
	map: {
		mapbox: {
			apiKey: "pk.eyJ1IjoibGl2ZXNvbHV0aW9ucyIsImEiOiJjbGZjb25jZ3MwODg4NDJubXJsdGtxYXNtIn0.juKSL4czqbrFYyPJtRT5rg"
		}
	}
};